import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom';
import { BASE_URL, UserContext } from '../contexts/UserContext';
import Loader from '../components/Loader/Loader';

const Authors = () => {
  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setError} = useContext(UserContext)
  useEffect(() => {
    const getAuthors = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${BASE_URL}/users/all-users`);
        setAuthors(data.user);
      } catch (error) {
        setError(error.response.data.message);
      } finally {
        setLoading(false);
      }
    }
    getAuthors();
  },[])

  return (
    loading ? (
      <Loader />
    ): (
      <section className="authors">
        {authors?.length > 0 ? (<div className="container authors__container">
          {
            authors.map(items => {
              return (
                <Link to={`/posts/users/${items._id}`} key={items._id} className='author'>
                  <div className="author__avatar">
                    <img src={items.profile?.secure_url} alt="" />
                  </div>
                  <div className="author__info">
                    <h4>{items.name}</h4>
                    <p>{items.postCount.length}</p>

                  </div>
                </Link>
              )
            })
          }
        </div>) : (
          <h2 className='center'>No posts found</h2>
        )}
      </section>
    )
  )
}

export default Authors